import styled from 'styled-components';

export const H1 = styled.h1`
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-size: 28px;
  font-weight: 900;
  line-height: 120%;
  color: #1F2833;

  @media (min-width: 1200px) {
    font-size: 34px;
  }

  > span {
    color: #0077FF;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  color: #475266;

  @media (min-width: 1200px) {
    font-size: 22px;
  }
`;

export const H2 = styled.h2`
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 140%;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #969CA3;

  @media (min-width: 1200px) {
    font-size: 26px;
  }
`;

export const H4 = styled.h4`
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 140%;
  color: rgba(71, 82, 102, 1);
  text-transform: uppercase;
`;

H1.displayName = 'H1';
H2.displayName = 'H2';
H4.displayName = 'H4';
Description.displayName = 'Description';
